/**
 * Copy to clipboard & return a callback to be acted upon
 Example usage:

 copyContentToClipboard(
 myTextareaRef,
 (success) => success ? alert('Copied!') : null
 )

 * @param target
 * @param successCallback
 */
export const copyContentToClipboard = (target: HTMLTextAreaElement | HTMLInputElement, successCallback?: Function) => {
  if (!target || !target.value || !target.value.length) {
    return;
  }

  try {
    target.select();
    document.execCommand('copy');

    // unset the selection after copying
    window.getSelection().removeAllRanges();

    // un-focus the target arising from having called `.select()` on it
    target.blur();

    if (successCallback) {
      successCallback(true);
    }
  } catch (err) {
    console.error('Error while copying textarea content.', {
      target,
      err,
    });

    if (successCallback) {
      successCallback(false);
    }
  }
};